<div class="spinner-overlay" *ngIf="loading">
    <div class="spinner-container">
        <div class="spinner"></div>
    </div>
</div>

